G.Input = G.Input || {};
G.Input.createCustomBlockInputHandler = function createCustomBlockInputHandler(callbackBlocked) {

  // imports
  var EventType = G.Input.EventType;

  //

  var signal = new Phaser.Signal();

  var customInput = {
    // custom input handler interface
    handleEventShared:    handleEventShared,
    handleEventExclusive: handleEventExclusive,
    cancelEvent:          cancelEvent,

    // custom
    signal: signal
  };

  return customInput;

  function handleEventShared(eventType, pointer) {
    return true;
  }

  function handleEventExclusive(eventType, pointer) {
    signal.dispatch(eventType);
    return true;
  }

  function cancelEvent(eventType) {
  }

};
